export const CONTINENT_NAMES = {
  aas: __("common.continents.aas"),
  mea: __("common.continents.mea"),
  eu: __("common.continents.eu"),
  ap: __("common.continents.ap"),
  as: __("common.continents.as"),
}

// TODO: used just for sending continent info with tracking events, hardcoded, maybe will need update in the future
// not used loading from location API as those data are needed right when page is loaded and we do not want to wait for them
export const CONTINENT_BY_COUNTRY = {
  DE: "EU",
  US: "NA",
  GB: "EU",
  IT: "EU",
  AT: "EU",
  ES: "EU",
  CN: "AS",
  FR: "EU",
  CA: "NA",
  GR: "EU",
  CZ: "EU",
  TR: "AS",
  CH: "EU",
  PL: "EU",
  NL: "EU",
  TH: "AS",
  MX: "NA",
  PT: "EU",
  AE: "AS",
  BE: "EU",
  AU: "OC",
  RU: "EU",
  RO: "EU",
  SK: "EU",
  HR: "EU",
  IN: "AS",
  MY: "AS",
  PH: "AS",
  EG: "AF",
  HU: "EU",
  DK: "EU",
  IL: "AS",
  DO: "NA",
  MA: "AF",
  IE: "EU",
  SG: "AS",
  NZ: "OC",
  VN: "AS",
  BG: "EU",
  JP: "AS",
  SE: "EU",
  SI: "EU",
  CU: "NA",
  NO: "EU",
  CY: "AS",
  TW: "AS",
  CO: "SA",
  FI: "EU",
  IS: "EU",
  KR: "AS",
  ID: "AS",
  PE: "SA",
  KH: "AS",
  LU: "EU",
  CR: "NA",
  MT: "EU",
  LT: "EU",
  LV: "EU",
  EC: "SA",
  OM: "AS",
  CL: "SA",
  ME: "EU",
  UA: "EU",
  VE: "SA",
  PK: "AS",
  ZA: "AF",
  GT: "NA",
  PA: "NA",
  JM: "NA",
  SA: "AS",
  QA: "AS",
  SV: "NA",
  BS: "NA",
  LB: "AS",
  IR: "AS",
  JO: "AS",
  MV: "AS",
  RS: "EU",
  AW: "NA",
  BR: "SA",
  KE: "AF",
  LR: "AF",
  AR: "SA",
  GE: "AS",
  KW: "AS",
  LK: "AS",
  GH: "AF",
  MM: "AS",
  NP: "AS",
  TT: "NA",
  AL: "EU",
  IQ: "AS",
  TN: "AF",
  ET: "AF",
  NG: "AF",
  FJ: "OC",
  MU: "AF",
  BH: "AS",
  HN: "NA",
  BD: "AS",
  KZ: "AS",
  BO: "SA",
  MK: "EU",
  KY: "NA",
  TZ: "AF",
  BA: "EU",
  UY: "SA",
  BB: "NA",
  TC: "NA",
  NI: "NA",
  XK: "EU",
  LC: "NA",
  NA: "AF",
  PF: "OC",
  UZ: "AS",
  KG: "AS",
  ZM: "AF",
  BN: "AS",
  BY: "EU",
  EE: "EU",
  HT: "NA",
  AG: "NA",
  SX: "NA",
  CV: "AF",
  PW: "OC",
  CM: "AF",
  GM: "AF",
  AO: "AF",
  LA: "AS",
  DZ: "AF",
  UG: "AF",
  AM: "AS",
  SC: "AF",
  BZ: "NA",
  MN: "AS",
  MZ: "AF",
  PY: "SA",
  AZ: "AS",
  VU: "OC",
  MD: "EU",
  ZW: "AF",
  GL: "NA",
  TJ: "AS",
  RW: "AF",
  SN: "AF",
  CI: "AF",
  GY: "SA",
  BF: "AF",
  CW: "NA",
  BJ: "AF",
  TG: "AF",
  FO: "EU",
  GD: "NA",
  AF: "AS",
  SD: "AF",
  GI: "EU",
  SL: "AF",
  GN: "AF",
  MG: "AF",
  CD: "AF",
  JE: "EU",
  BL: "NA",
  KN: "NA",
  CK: "OC",
  SR: "SA",
  BW: "AF",
  MR: "AF",
  ML: "AF",
  NE: "AF",
  CG: "AF",
  ER: "AF",
  SO: "AF",
  WS: "OC",
  NC: "OC",
  VG: "NA",
  SJ: "EU",
  VC: "NA",
  IM: "EU",
  MW: "AF",
  DJ: "AF",
  DM: "NA",
  PG: "OC",
  SS: "AF",
  LS: "AF",
  BT: "AS",
  SB: "OC",
  ST: "AF",
  GG: "EU",
  TM: "AS",
  TD: "AF",
  TO: "OC",
  BI: "AF",
  KP: "AS",
  AI: "NA",
  GA: "AF",
  LY: "AF",
  SY: "AS",
  FM: "OC",
  MH: "OC",
  TL: "AS",
  SZ: "AF",
  CX: "OC",
  YE: "AS",
  CF: "AF",
  FK: "SA",
  KI: "OC",
  MC: "EU",
  GW: "AF",
  NR: "OC",
  NU: "OC",
  MF: "NA",
  TV: "OC",
  AX: "EU",
  CC: "OC",
  GQ: "AF",
  KM: "AF",
  NF: "OC",
  PM: "NA",
  AD: "EU",
  WF: "OC",
  SH: "AF",
}
